import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './About.css';

const About = () => {

    useEffect(() => {
        AOS.init({
                duration: 2000,
            });
        AOS.refresh();
      }, []);
    return (
        <section className="about-wrapper">
            <Container>
                <Row>
                    <Col md={12} lg={6} >
                        <div className="about-right mt-5 mt-lg-0" style={{margin:"15px"}}>
                            <div className="about-content text-start" data-aos="zoom-in">
                                <h1>Welcome to सावली</h1>
                                <p>We are a warm and welcoming community for seniors, offering a range of amenities and services designed to promote independence and enhance quality of life. Our goal is to create a comfortable and supportive environment where residents can thrive and enjoy their golden years. Our dedicated team of professionals is committed to providing the highest level of care and support to all of our residents. We offer a variety of activities and programs to keep our residents engaged and active, as well as personalized care plans to meet the unique needs of each individual.</p>
                                <a href='/page/about'>About Us</a>
                            </div>
                        </div>                        
                    </Col>
                    <Col md={12} lg={6}>
                        <div className="about-right mt-5 mt-lg-0" style={{margin:"15px"}}>
                            <div className="about-content text-start" data-aos="zoom-in">
                                <h1>Our Commitment</h1>
                                <p>We are a state-of-the-art facility dedicated to helping individuals overcome physical, cognitive, and emotional challenges and achieve their full potential. Our highly trained and compassionate staff is committed to providing personalized, evidence-based care to help our clients reach their goals and lead fulfilling lives.At सावली, we offer a wide range of services, including physical therapy, wound managment, old age care, and more. We also offer specialized programs for clients with specific needs.</p>
                                <a href='/page/about'>About Us</a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default About;